import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as templateApi from '../services/documentTemplateService';

const templateKeys = {
  list: (projectId: string) => ['documentTemplates', projectId] as const,
};

export function useDocumentTemplates(projectId: string) {
  return useQuery({
    queryKey: templateKeys.list(projectId),
    queryFn: () => templateApi.fetchTemplatesWithCategories(projectId),
    enabled: !!projectId,
  });
}

export function useCreateDocumentTemplateCategory(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string }) => templateApi.createCategory(projectId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: templateKeys.list(projectId) }),
  });
}

export function useCreateDocumentTemplate(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { categoryId: string; name: string; description?: string; content?: unknown }) =>
      templateApi.createTemplate(projectId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: templateKeys.list(projectId) }),
  });
}

export function useUpdateDocumentTemplate(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { templateId: string; data: { name?: string; description?: string; content?: unknown } }) =>
      templateApi.updateTemplate(projectId, params.templateId, params.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: templateKeys.list(projectId) }),
  });
}

export function useDeleteDocumentTemplate(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) => templateApi.deleteTemplate(projectId, templateId),
    onSuccess: () => qc.invalidateQueries({ queryKey: templateKeys.list(projectId) }),
  });
}
